import { connect } from 'react-redux'
import component from './component'


const mapStateToProps = state => ({
    itemsLength: state.items.ids.length
})

export default connect(
    mapStateToProps,
    null
)(component)
